import { render, staticRenderFns } from "./logDetail.vue?vue&type=template&id=b71e68cc&scoped=true&"
import script from "./logDetail.vue?vue&type=script&lang=js&"
export * from "./logDetail.vue?vue&type=script&lang=js&"
import style0 from "./logDetail.vue?vue&type=style&index=0&id=b71e68cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71e68cc",
  null
  
)

export default component.exports